import React from 'react';
import { SearchIcon, XIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
interface SearchGrammarProps {
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  resultsCount?: number;
  className?: string;
}
export function SearchGrammar({
  value,
  onChange,
  onClear,
  resultsCount,
  className = ''
}: SearchGrammarProps) {
  const {
    isArabic
  } = useLanguage();
  return <div className={`relative ${className}`} data-id="element-1342">
      <div className="relative" data-id="element-1343">
        <SearchIcon className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500" data-id="element-1344" />
        <input type="text" value={value} onChange={e => onChange(e.target.value)} placeholder={isArabic ? 'ابحث في القواعد...' : 'Search grammar topics...'} className="w-full pl-12 pr-12 py-3 rounded-xl bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent transition-all duration-200" dir={isArabic ? 'rtl' : 'ltr'} data-id="element-1345" />
        {value && <button onClick={onClear} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 transition-colors" data-id="element-1346">
            <XIcon className="w-5 h-5" data-id="element-1347" />
          </button>}
      </div>
      {typeof resultsCount !== 'undefined' && value && <div className="absolute left-0 right-0 mt-2 text-sm text-gray-500 dark:text-gray-400" data-id="element-1348">
          {resultsCount}{' '}
          {isArabic ? `${resultsCount === 1 ? 'نتيجة' : 'نتائج'}` : `${resultsCount === 1 ? 'result' : 'results'}`}
        </div>}
    </div>;
}